import { connect } from "react-redux";
import { EditBookingComponent } from "./EditBookingComponent";
import { editBookingGetBooking, editBookingPopulateFlow, editBookingSetValues, editBookingReset } from "../../store/actions/editBooking";
import { deleteBookingAction } from "../../store/actions/deleteBooking";

const mapStateToProps = ({ editBookingState, settingsReducer }) => ({
    editBookingStep: editBookingState.editBookingCurrentStep,
    bookingCode: editBookingState.bookingCode,
    storeId: editBookingState.selectedStore ? editBookingState.selectedStore.id : '',
    restaurantName: editBookingState.restaurantName,
    isRequestingStoresList: editBookingState.isRequestingStoresList,
    storesList: editBookingState.storesList,
    isRequestingBookingInfo: editBookingState.isRequestingBookingInfo,
    bookingInfo: editBookingState.bookingInfo,
    
    hasErrorStoresListRequest: editBookingState.hasErrorStoresListRequest,
    hasErrorRequestBookingInfo: editBookingState.hasErrorRequestBookingInfo,

    translations: settingsReducer.translations,
});

const mapDispatchToProps = dispatch => ({
    getBookingInfo: ({ bookingCode, restaurantName, restaurantId }) => dispatch(editBookingGetBooking({ bookingCode, restaurantName, restaurantId })),
    setBookingInfo: (bookingCode, restaurantName) => dispatch(editBookingSetValues({ bookingCode, restaurantName })),
    editBookingClicked: (history) => dispatch(editBookingPopulateFlow(history)),
    deleteBookingClicked: ({ bookingCode, storeId }) => dispatch(deleteBookingAction({ storeId, bookingCode })),
    resetState: () => dispatch(editBookingReset()),
});

export const EditBooking = connect(mapStateToProps, mapDispatchToProps)(EditBookingComponent);


// WEBPACK FOOTER //
// ./src/containers/EditBooking/index.js